import { AxiosInstance } from "axios";
import { handleUnauthorized } from "@/utils/auth-utils";

export const attachUnauthorizedHandler = (instance: AxiosInstance) => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        handleUnauthorized();
      }
      return Promise.reject(error);
    },
  );
};
